module.exports = __webpack_public_path__ + "fonts/Adelle_ExtraBoldItalic.c2a1a642.woff";